import { SnapCarouselInstance, SnapCarouselThumbs } from 'customs/snap-carousel'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'

class CarouselMain extends HTMLElement {
  constructor() {
    super()

    const options = {
      loop: this.hasAttribute('data-loop'),
      autoplay: this.hasAttribute('data-autoplay') && this.getAttribute('data-autoplay'),
      watchHeight: this.hasAttribute('data-watch-height'),
      direction: this.getAttribute('data-direction'),
      asNavFor: this.getAttribute('data-as-nav-for')
    }
    if (options.asNavFor) {
      this.instance = new SnapCarouselThumbs(this, options)
    } else {
      this.instance = new SnapCarouselInstance(this, options)
    }

    globalEmitter.on(emitterProps.product.updateVariant, (variant) => {
      this.updateImage(variant)
    })
  }

  updateImage(variant) {
    const position = variant?.featured_image?.position - 1
    this.instance.setActiveSlide(position)
  }
}

customElements.define('carousel-main', CarouselMain)
